<template>
  <section class="gig-unavailable">
    <h1>Bu iş ilanına ulaşılamıyor</h1>
    <p>İlan kaldırılmış veya şu anda erişime kapalı olabilir.</p>
    <router-link to="/">Diğer hizmetleri keşfet</router-link>
  </section>
</template>

<script>
  import { clearBoundSchemaMarkup } from '@/utils/schema'

  export default {
    name: 'GigUnavailable',
    mounted() {
      clearBoundSchemaMarkup()
      this.$store.state.indexHTMLTitle = 'İş ilanına ulaşılamıyor - Bionluk'
      this.$store.state.indexHTMLMetaDescription = 'Bu iş ilanı kaldırılmış veya şu anda erişime kapalı olabilir.'

      // Rendertron consumes the status; noindex also covers client-rendered responses.
      document.querySelectorAll('meta[name="render:status_code"], meta[name="render:header"]').forEach(node => node.remove())
      this.errorHeadNodes = [['render:status_code', '404'], ['robots', 'noindex']].map(([name, content]) => {
        const node = document.createElement('meta')
        node.name = name
        node.content = content
        document.head.appendChild(node)
        return node
      })
    },
    beforeDestroy() {
      // Do not carry the error status or noindex into the next SPA page.
      const nodes = this.errorHeadNodes || []
      nodes.forEach(node => node.remove())
    }
  }
</script>

<style scoped>
  .gig-unavailable {
    padding: 100px 24px;
    min-height: 40vh;
    text-align: center;
    color: #242424;
  }

  .gig-unavailable h1 {
    font-size: 24px;
  }

  .gig-unavailable p {
    margin: 16px 0 24px;
  }

  .gig-unavailable a {
    color: #d92e50;
    text-decoration: underline;
  }
</style>
